"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputError = exports.TypeError = exports.ArgumentError = exports.InvalidArgumentError = exports.InvalidFunctionError = exports.PenguinoError = void 0;
class PenguinoError extends Error {
    constructor(message, node) {
        super(message);
        this.node = node;
        this.name = node.expression.revert().lexeme;
        this.line = node.expression.revert().line;
        this.start = node.expression.revert().start;
        this.end = node.expression.revert().end;
    }
}
exports.PenguinoError = PenguinoError;
class InvalidFunctionError extends PenguinoError {
    constructor(message, node) {
        super(message, node);
        this.node = node;
    }
}
exports.InvalidFunctionError = InvalidFunctionError;
class InvalidArgumentError extends PenguinoError {
    constructor(message, node, closestMatch) {
        super(message, node);
        this.node = node;
        this.closestMatch = closestMatch;
    }
}
exports.InvalidArgumentError = InvalidArgumentError;
class ArgumentError extends PenguinoError {
    constructor(message, node) {
        super(message, node);
        this.node = node;
    }
}
exports.ArgumentError = ArgumentError;
class TypeError extends PenguinoError {
    constructor(message, node) {
        super(message, node);
        this.node = node;
    }
}
exports.TypeError = TypeError;
class InputError extends PenguinoError {
    constructor(message, node) {
        super(message, node);
        this.node = node;
    }
}
exports.InputError = InputError;
//# sourceMappingURL=error.js.map